import React, { useState, useEffect, useMemo } from 'react';
import {
  Phone,
  Mail,
  MapPin,
  Fuel,
  Clock,
  FileText,
  Users,
  Search,
  Plus,
  Edit2,
  Trash2,
  Save,
  X,
  Shield
} from 'lucide-react';
import { createClient } from '@supabase/supabase-js';

// YOUR SUPABASE CREDENTIALS - ALREADY FILLED IN!
const SUPABASE_URL = 'https://hkuwlhxwcloneawiblme.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhrdXdsaHh3Y2xvbmVhd2libG1lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkwMjk5ODMsImV4cCI6MjA4NDYwNTk4M30.uUjiiyjEXOx75g7giow8Z1xGbXyS4I-F6wMIeGGtejU';

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Nigeria States + LGAs (36 states + FCT)
const NIGERIA_STATE_LGAS = {
  Abia: [
    'Aba North','Aba South','Arochukwu','Bende','Ikwuano','Isiala Ngwa North','Isiala Ngwa South','Isuikwuato','Obi Ngwa','Ohafia','Osisioma','Ugwunagbo','Ukwa East','Ukwa West','Umuahia North','Umuahia South','Umu Nneochi'
  ],
  Adamawa: [
    'Demsa','Fufore','Ganye','Girei','Gombi','Guyuk','Hong','Jada','Lamurde','Madagali','Maiha','Mayo-Belwa','Michika','Mubi North','Mubi South','Numan','Shelleng','Song','Toungo','Yola North','Yola South'
  ],
  'Akwa Ibom': [
    'Abak','Eastern Obolo','Eket','Esit Eket','Essien Udim','Etim Ekpo','Etinan','Ibeno','Ibesikpo Asutan','Ibiono-Ibom','Ika','Ikono','Ikot Abasi','Ikot Ekpene','Ini','Itu','Mbo','Mkpat-Enin','Nsit-Atai','Nsit-Ibom','Nsit-Ubium','Obot Akara','Okobo','Onna','Oron','Oruk Anam','Udung-Uko','Ukanafun','Uruan','Urue-Offong/Oruko','Uyo'
  ],
  Anambra: [
    'Aguata','Anambra East','Anambra West','Anaocha','Awka North','Awka South','Ayamelum','Dunukofia','Ekwusigo','Idemili North','Idemili South','Ihiala','Njikoka','Nnewi North','Nnewi South','Ogbaru','Onitsha North','Onitsha South','Orumba North','Orumba South','Oyi'
  ],
  Bauchi: [
    'Alkaleri','Bauchi','Bogoro','Damban','Darazo','Dass','Gamawa','Ganjuwa','Giade','Itas/Gadau','Jama\'are','Katagum','Kirfi','Misau','Ningi','Shira','Tafawa Balewa','Toro','Warji','Zaki'
  ],
  Bayelsa: ['Brass','Ekeremor','Kolokuma/Opokuma','Nembe','Ogbia','Sagbama','Southern Ijaw','Yenagoa'],
  Benue: [
    'Ado','Agatu','Apa','Buruku','Gboko','Guma','Gwer East','Gwer West','Katsina-Ala','Konshisha','Kwande','Logo','Makurdi','Obi','Ogbadibo','Ohimini','Oju','Okpokwu','Oturkpo','Tarka','Ukum','Ushongo','Vandeikya'
  ],
  Borno: [
    'Abadam','Askira/Uba','Bama','Bayo','Biu','Chibok','Damboa','Dikwa','Gubio','Guzamala','Gwoza','Hawul','Jere','Kaga','Kala/Balge','Konduga','Kukawa','Kwaya Kusar','Mafa','Magumeri','Maiduguri','Marte','Mobbar','Monguno','Ngala','Nganzai','Shani'
  ],
  'Cross River': [
    'Abi','Akamkpa','Akpabuyo','Bakassi','Bekwarra','Biase','Boki','Calabar Municipal','Calabar South','Etung','Ikom','Obanliku','Obubra','Obudu','Odukpani','Ogoja','Yakuur','Yala'
  ],
  Delta: [
    'Aniocha North','Aniocha South','Bomadi','Burutu','Ethiope East','Ethiope West','Ika North East','Ika South','Isoko North','Isoko South','Ndokwa East','Ndokwa West','Okpe','Oshimili North','Oshimili South','Patani','Sapele','Udu','Ughelli North','Ughelli South','Ukwuani','Uvwie','Warri North','Warri South','Warri South West'
  ],
  Ebonyi: ['Abakaliki','Afikpo North','Afikpo South','Ebonyi','Ezza North','Ezza South','Ikwo','Ishielu','Ivo','Izzi','Ohaozara','Ohaukwu','Onicha'],
  Edo: [
    'Akoko-Edo','Egor','Esan Central','Esan North-East','Esan South-East','Esan West','Etsako Central','Etsako East','Etsako West','Igueben','Ikpoba Okha','Orhionmwon','Oredo','Ovia North-East','Ovia South-West','Owan East','Owan West','Uhunmwonde'
  ],
  Ekiti: [
    'Ado Ekiti','Efon','Ekiti East','Ekiti South-West','Ekiti West','Emure','Gbonyin','Ido Osi','Ijero','Ikere','Ikole','Ilejemeje','Irepodun/Ifelodun','Ise/Orun','Moba','Oye'
  ],
  Enugu: [
    'Aninri','Awgu','Enugu East','Enugu North','Enugu South','Ezeagu','Igbo Etiti','Igbo Eze North','Igbo Eze South','Isi Uzo','Nkanu East','Nkanu West','Nsukka','Oji River','Udenu','Udi','Uzo-Uwani'
  ],
  Gombe: ['Akko','Balanga','Billiri','Dukku','Funakaye','Gombe','Kaltungo','Kwami','Nafada','Shongom','Yamaltu/Deba'],
  Imo: [
    'Aboh Mbaise','Ahiazu Mbaise','Ehime Mbano','Ezinihitte','Ideato North','Ideato South','Ihitte/Uboma','Ikeduru','Isiala Mbano','Isu','Mbaitoli','Ngor Okpala','Njaba','Nkwerre','Nwangele','Obowo','Oguta','Ohaji/Egbema','Okigwe','Orlu','Orsu','Oru East','Oru West','Owerri Municipal','Owerri North','Owerri West'
  ],
  Jigawa: [
    'Auyo','Babura','Biriniwa','Birnin Kudu','Buji','Dutse','Gagarawa','Garki','Gumel','Guri','Gwaram','Gwiwa','Hadejia','Jahun','Kafin Hausa','Kazaure','Kiri Kasama','Kiyawa','Maigatari','Malam Madori','Miga','Ringim','Roni','Sule Tankarkar','Taura','Yankwashi'
  ],
  Kaduna: [
    'Birnin Gwari','Chikun','Giwa','Igabi','Ikara','Jaba','Jema\'a','Kachia','Kaduna North','Kaduna South','Kagarko','Kajuru','Kaura','Kauru','Kubau','Kudan','Lere','Makarfi','Sabon Gari','Sanga','Soba','Zangon Kataf','Zaria'
  ],
  Kano: [
    'Ajingi','Albasu','Bagwai','Bebeji','Bichi','Bunkure','Dala','Dambatta','Dawakin Kudu','Dawakin Tofa','Doguwa','Fagge','Gabasawa','Garko','Garun Mallam','Gaya','Gezawa','Gwale','Gwarzo','Kabo','Kano Municipal','Karaye','Kibiya','Kiru','Kumbotso','Kunchi','Kura','Madobi','Makoda','Minjibir','Nasarawa','Rano','Rimin Gado','Rogo','Shanono','Sumaila','Takai','Tarauni','Tofa','Tsanyawa','Tudun Wada','Ungogo','Warawa','Wudil'
  ],
  Katsina: [
    'Bakori','Batagarawa','Batsari','Baure','Bindawa','Charanchi','Dan Musa','Dandume','Danja','Daura','Dutsi','Dutsin-Ma','Faskari','Funtua','Ingawa','Jibia','Kafur','Kaita','Kankara','Kankia','Katsina','Kurfi','Kusada','Mai\'Adua','Malumfashi','Mani','Mashi','Matazu','Musawa','Rimi','Sabuwa','Safana','Sandamu','Zango'
  ],
  Kebbi: [
    'Aleiro','Arewa Dandi','Argungu','Augie','Bagudo','Birnin Kebbi','Bunza','Dandi','Fakai','Gwandu','Jega','Kalgo','Koko/Besse','Maiyama','Ngaski','Sakaba','Shanga','Suru','Wasagu/Danko','Yauri','Zuru'
  ],
  Kogi: [
    'Adavi','Ajaokuta','Ankpa','Bassa','Dekina','Ibaji','Idah','Igalamela-Odolu','Ijumu','Kabba/Bunu','Kogi','Lokoja','Mopa-Muro','Ofu','Ogori/Magongo','Okehi','Okene','Olamaboro','Omala','Yagba East','Yagba West'
  ],
  Kwara: ['Asa','Baruten','Edu','Ekiti (Kwara)','Ifelodun','Ilorin East','Ilorin South','Ilorin West','Irepodun','Isin','Kaiama','Moro','Offa','Oke Ero','Oyun','Pategi'],
  Lagos: [
    'Agege','Ajeromi-Ifelodun','Alimosho','Amuwo-Odofin','Apapa','Badagry','Epe','Eti-Osa','Ibeju-Lekki','Ifako-Ijaiye','Ikeja','Ikorodu','Kosofe','Lagos Island','Lagos Mainland','Mushin','Ojo','Oshodi-Isolo','Shomolu','Surulere'
  ],
  Nasarawa: ['Akwanga','Awe','Doma','Karu','Keana','Keffi','Kokona','Lafia','Nasarawa','Nasarawa Egon','Obi','Toto','Wamba'],
  Niger: [
    'Agaie','Agwara','Bida','Borgu','Bosso','Chanchaga','Edati','Gbako','Gurara','Katcha','Kontagora','Lapai','Lavun','Magama','Mariga','Mashegu','Mokwa','Moya','Paikoro','Rafi','Rijau','Shiroro','Suleja','Tafa','Wushishi'
  ],
  Ogun: [
    'Abeokuta North','Abeokuta South','Ado-Odo/Ota','Egbado North','Egbado South','Ewekoro','Ifo','Ijebu East','Ijebu North','Ijebu North East','Ijebu Ode','Ikenne','Imeko Afon','Ipokia','Obafemi Owode','Odeda','Odogbolu','Ogun Waterside','Remo North','Shagamu'
  ],
  Ondo: [
    'Akoko North-East','Akoko North-West','Akoko South-East','Akoko South-West','Akure North','Akure South','Ese Odo','Idanre','Ifedore','Ilaje','Ile Oluji/Okeigbo','Irele','Odigbo','Okitipupa','Ondo East','Ondo West','Ose','Owo'
  ],
  Osun: [
    'Aiyedaade','Aiyedire','Atakunmosa East','Atakunmosa West','Boluwaduro','Boripe','Ede North','Ede South','Egbedore','Ejigbo','Ife Central','Ife East','Ife North','Ife South','Ifedayo','Ifelodun','Ila','Ilesa East','Ilesa West','Irepodun','Irewole','Isokan','Iwo','Obokun','Odo Otin','Ola Oluwa','Olorunda','Oriade','Orolu','Osogbo'
  ],
  Oyo: [
    'Afijio','Akinyele','Atiba','Atisbo','Egbeda','Ibadan North','Ibadan North-East','Ibadan North-West','Ibadan South-East','Ibadan South-West','Ibarapa Central','Ibarapa East','Ibarapa North','Ido','Irepo','Iseyin','Itesiwaju','Iwajowa','Kajola','Lagelu','Ogbomosho North','Ogbomosho South','Ogo Oluwa','Olorunsogo','Oluyole','Ona Ara','Orelope','Ori Ire','Oyo East','Oyo West','Saki East','Saki West','Surulere (Oyo)'
  ],
  Plateau: ['Barkin Ladi','Bassa','Bokkos','Jos East','Jos North','Jos South','Kanam','Kanke','Langtang North','Langtang South','Mangu','Mikang','Pankshin','Qua\'an Pan','Riyom','Shendam','Wase'],
  Rivers: [
    'Abua/Odual','Ahoada East','Ahoada West','Akuku-Toru','Andoni','Asari-Toru','Bonny','Degema','Emohua','Eleme','Etche','Gokana','Ikwerre','Khana','Obio/Akpor','Ogba/Egbema/Ndoni','Ogu/Bolo','Okrika','Omuma','Opobo/Nkoro','Oyigbo','Port Harcourt','Tai'
  ],
  Sokoto: [
    'Binji','Bodinga','Dange Shuni','Gada','Goronyo','Gudu','Gwadabawa','Illela','Isa','Kebbe','Kware','Rabah','Sabon Birni','Shagari','Silame','Sokoto North','Sokoto South','Tambuwal','Tangaza','Tureta','Wamako','Wurno','Yabo'
  ],
  Taraba: ['Ardo Kola','Bali','Donga','Gashaka','Gassol','Ibi','Jalingo','Karim Lamido','Kumi','Lau','Sardauna','Takum','Ussa','Wukari','Yorro','Zing'],
  Yobe: ['Bade','Bursari','Damaturu','Fika','Fune','Geidam','Gujba','Gulani','Jakusko','Karasuwa','Machina','Nangere','Nguru','Potiskum','Tarmuwa','Yunusari','Yusufari'],
  Zamfara: ['Anka','Bakura','Birnin Magaji/Kiyaw','Bukkuyum','Bungudu','Gummi','Gusau','Kaura Namoda','Maradun','Maru','Shinkafi','Talata Mafara','Tsafe','Zurmi'],
  FCT: ['Abaji','Bwari','Gwagwalada','Kuje','Kwali','Municipal Area Council']
};

export default function GasVendorRegistry() {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const ADMIN_PASSWORD = 'admin123'; // Change this to your desired password

  const handleAdminLogin = (e) => {
    e.preventDefault();
    if (passwordInput === ADMIN_PASSWORD) {
      setIsAdmin(true);
      setShowAdminLogin(false);
      setPasswordInput('');
    } else {
      alert('Incorrect password');
      setPasswordInput('');
    }
  };

  const [formData, setFormData] = useState({
    businessName: '',
    contactPerson: '',
    phone: '',
    email: '',
    address: '',
    state: '',
    lga: '',
    gasType: 'LPG',
    serviceType: 'Retail',
    operatingHours: '',
    licenseNumber: '',
    deliveryAvailable: 'Yes',
    pricePerKg: '',
    minimumOrder: '',
    deliveryAreas: ''
  });

  const states = useMemo(() => Object.keys(NIGERIA_STATE_LGAS).sort((a, b) => a.localeCompare(b)), []);
  const lgasForSelectedState = useMemo(() => {
    if (!formData.state) return [];
    return NIGERIA_STATE_LGAS[formData.state] || [];
  }, [formData.state]);

  // Load vendors from Supabase
  useEffect(() => {
    loadVendors();
  }, []);

  const loadVendors = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('vendors')
        .select('*')
        .order('date_added', { ascending: false });

      if (error) throw error;
      setVendors(data || []);
    } catch (error) {
      console.error('Error loading vendors:', error);
      alert('Error loading vendors: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // If state changes, reset LGA to avoid mismatch
    if (name === 'state') {
      setFormData((prev) => ({ ...prev, state: value, lga: '' }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      businessName: '',
      contactPerson: '',
      phone: '',
      email: '',
      address: '',
      state: '',
      lga: '',
      gasType: 'LPG',
      serviceType: 'Retail',
      operatingHours: '',
      licenseNumber: '',
      deliveryAvailable: 'Yes',
      pricePerKg: '',
      minimumOrder: '',
      deliveryAreas: ''
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const vendorData = {
        business_name: formData.businessName,
        contact_person: formData.contactPerson,
        phone: formData.phone,
        email: formData.email,
        address: formData.address,
        state: formData.state,
        lga: formData.lga,
        gas_type: formData.gasType,
        service_type: formData.serviceType,
        operating_hours: formData.operatingHours,
        license_number: formData.licenseNumber,
        delivery_available: formData.deliveryAvailable,
        price_per_kg: formData.pricePerKg ? parseFloat(formData.pricePerKg) : null,
        minimum_order: formData.minimumOrder,
        delivery_areas: formData.deliveryAreas,
        last_updated: new Date().toISOString()
      };

      if (editingId) {
        // Update existing vendor
        const { error } = await supabase
          .from('vendors')
          .update(vendorData)
          .eq('id', editingId);

        if (error) throw error;
        alert('Vendor updated successfully!');
      } else {
        // Insert new vendor
        const { error } = await supabase
          .from('vendors')
          .insert([vendorData]);

        if (error) throw error;
        alert('Vendor added successfully!');
      }

      await loadVendors();
      resetForm();
    } catch (error) {
      console.error('Error saving vendor:', error);
      alert('Error saving vendor: ' + error.message);
    }
  };

  const handleEdit = (vendor) => {
    setFormData({
      businessName: vendor.business_name || '',
      contactPerson: vendor.contact_person || '',
      phone: vendor.phone || '',
      email: vendor.email || '',
      address: vendor.address || '',
      state: vendor.state || '',
      lga: vendor.lga || '',
      gasType: vendor.gas_type || 'LPG',
      serviceType: vendor.service_type || 'Retail',
      operatingHours: vendor.operating_hours || '',
      licenseNumber: vendor.license_number || '',
      deliveryAvailable: vendor.delivery_available || 'Yes',
      pricePerKg: vendor.price_per_kg || '',
      minimumOrder: vendor.minimum_order || '',
      deliveryAreas: vendor.delivery_areas || ''
    });
    setEditingId(vendor.id);
    setShowForm(true);
  };

  const handleDelete = async (vendorId) => {
    if (window.confirm('Are you sure you want to delete this vendor?')) {
      try {
        const { error } = await supabase
          .from('vendors')
          .delete()
          .eq('id', vendorId);

        if (error) throw error;

        await loadVendors();
        alert('Vendor deleted successfully!');
      } catch (error) {
        console.error('Error deleting vendor:', error);
        alert('Error deleting vendor: ' + error.message);
      }
    }
  };

  const filteredVendors = vendors.filter((vendor) => {
    const q = searchTerm.toLowerCase();
    return (
      (vendor.business_name || '').toLowerCase().includes(q) ||
      (vendor.lga || '').toLowerCase().includes(q) ||
      (vendor.state || '').toLowerCase().includes(q) ||
      (vendor.address || '').toLowerCase().includes(q)
    );
  });

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 font-medium">Loading vendors...</p>
        </div>
      </div>
    );
  }

  // Admin Login Modal
  if (showAdminLogin) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
          <div className="text-center mb-8">
            <Shield className="text-indigo-600 mx-auto mb-4" size={48} />
            <h1 className="text-3xl font-bold text-gray-800">Admin Login</h1>
            <p className="text-gray-600 mt-2">Enter password to access dashboard</p>
          </div>
          <form onSubmit={handleAdminLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Password</label>
              <input
                type="password"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                placeholder="Enter admin password"
                required
                autoFocus
              />
            </div>
            <div className="flex gap-3">
              <button
                type="submit"
                className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-6 rounded-lg font-semibold transition-all shadow-lg hover:shadow-xl"
              >
                Login
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowAdminLogin(false);
                  setPasswordInput('');
                }}
                className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-all"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-6 sm:py-8 px-3 sm:px-4">
      <div className="max-w-7xl mx-auto">
        {/* Admin Button - Top Right Corner */}
        {!isAdmin && (
          <div className="fixed top-4 right-4 z-40">
            <button
              onClick={() => setShowAdminLogin(true)}
              className="bg-gray-800 hover:bg-gray-900 text-white px-4 py-2 rounded-lg font-semibold flex items-center gap-2 transition-all shadow-lg hover:shadow-xl"
            >
              <Shield size={18} />
              Admin
            </button>
          </div>
        )}

        {/* Header */}
        <div className="bg-white rounded-2xl shadow-xl p-5 sm:p-8 mb-6">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div>
              <h1 className="text-2xl sm:text-4xl font-bold text-gray-800 flex items-center gap-3">
                <Fuel className="text-indigo-600" size={36} />
                Nigeria Gas Vendor Registry
              </h1>
              <p className="text-gray-600 mt-2">
                {isAdmin ? 'Admin Dashboard - Manage gas vendors' : 'Register your gas business'}
              </p>
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => setShowForm(!showForm)}
                className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 sm:px-6 py-3 rounded-lg font-semibold flex items-center gap-2 transition-all shadow-lg hover:shadow-xl"
              >
                {showForm ? <X size={20} /> : <Plus size={20} />}
                {showForm ? 'Cancel' : 'Add Vendor'}
              </button>
              {isAdmin && (
                <button
                  onClick={() => setIsAdmin(false)}
                  className="bg-red-600 hover:bg-red-700 text-white px-5 sm:px-6 py-3 rounded-lg font-semibold transition-all shadow-lg hover:shadow-xl"
                >
                  Logout
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Registration Form */}
        {showForm && (
          <div className="bg-white rounded-2xl shadow-xl p-5 sm:p-8 mb-6">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
              <FileText className="text-indigo-600" />
              {editingId ? 'Edit Vendor Details' : 'Register New Vendor'}
            </h2>

            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6">
              {/* Business Name */}
              <div className="md:col-span-2">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Business Name *</label>
                <input
                  type="text"
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                  placeholder="e.g., ABC Gas Solutions Ltd"
                />
              </div>

              {/* Contact Person */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Contact Person *</label>
                <input
                  type="text"
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                  placeholder="Full name"
                />
              </div>

              {/* Phone */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                  placeholder="e.g., 0801 234 5678"
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                  placeholder="vendor@example.com"
                />
              </div>

              {/* State */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">State *</label>
                <select
                  name="state"
                  value={formData.state}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                >
                  <option value="">Select state</option>
                  {states.map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>

              {/* LGA */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Local Government Area (LGA) *</label>
                <select
                  name="lga"
                  value={formData.lga}
                  onChange={handleInputChange}
                  required
                  disabled={!formData.state}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all disabled:opacity-60"
                >
                  <option value="">{formData.state ? 'Select LGA' : 'Select state first'}</option>
                  {lgasForSelectedState.map((lga) => (
                    <option key={lga} value={lga}>
                      {lga}
                    </option>
                  ))}
                </select>
              </div>

              {/* Address */}
              <div className="md:col-span-2">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Business Address *</label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                  placeholder="Complete street address"
                />
              </div>

              {/* Gas Type */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Gas Type *</label>
                <select
                  name="gasType"
                  value={formData.gasType}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                >
                  <option value="LPG">LPG (Cooking Gas)</option>
                  <option value="CNG">CNG (Compressed Natural Gas)</option>
                  <option value="LNG">LNG (Liquefied Natural Gas)</option>
                  <option value="Multiple">Multiple Types</option>
                </select>
              </div>

              {/* Service Type */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Service Type *</label>
                <select
                  name="serviceType"
                  value={formData.serviceType}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                >
                  <option value="Retail">Retail</option>
                  <option value="Wholesale">Wholesale</option>
                  <option value="Both">Both Retail & Wholesale</option>
                </select>
              </div>

              {/* Operating Hours */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Operating Hours</label>
                <input
                  type="text"
                  name="operatingHours"
                  value={formData.operatingHours}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                  placeholder="e.g., Mon-Sat: 8am-6pm"
                />
              </div>

              {/* License Number */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">License/Registration Number</label>
                <input
                  type="text"
                  name="licenseNumber"
                  value={formData.licenseNumber}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                  placeholder="DPR/LPGRA registration number"
                />
              </div>

              {/* Delivery Available */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Delivery Service *</label>
                <select
                  name="deliveryAvailable"
                  value={formData.deliveryAvailable}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                >
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              {/* Price Per Kg */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Price Per Kg (₦)</label>
                <input
                  type="number"
                  name="pricePerKg"
                  value={formData.pricePerKg}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                  placeholder="e.g., 1200"
                />
              </div>

              {/* Minimum Order */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Minimum Order (Kg)</label>
                <input
                  type="text"
                  name="minimumOrder"
                  value={formData.minimumOrder}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                  placeholder="e.g., 6kg, 12.5kg, 50kg"
                />
              </div>

              {/* Delivery Areas */}
              <div className="md:col-span-2">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Delivery Areas (if applicable)</label>
                <textarea
                  name="deliveryAreas"
                  value={formData.deliveryAreas}
                  onChange={handleInputChange}
                  rows="2"
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                  placeholder="e.g., Ikeja, Surulere, Victoria Island, Lekki"
                />
              </div>

              {/* Submit Button */}
              <div className="md:col-span-2 flex flex-col sm:flex-row gap-3 sm:gap-4">
                <button
                  type="submit"
                  className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-6 rounded-lg font-semibold flex items-center justify-center gap-2 transition-all shadow-lg hover:shadow-xl"
                >
                  <Save size={20} />
                  {editingId ? 'Update Vendor' : 'Register Vendor'}
                </button>
                <button
                  type="button"
                  onClick={resetForm}
                  className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-all"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Search - Admin Only */}
        {isAdmin && (
          <div className="bg-white rounded-2xl shadow-xl p-5 sm:p-6 mb-6">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex-1 max-w-md relative">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <input
                  type="text"
                  placeholder="Search vendors..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                />
              </div>
              <div className="flex items-center gap-2 bg-indigo-100 px-5 sm:px-6 py-3 rounded-lg">
                <Users className="text-indigo-600" size={24} />
                <div>
                  <p className="text-sm text-gray-600">Total Vendors</p>
                  <p className="text-2xl font-bold text-indigo-600">{vendors.length}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Public Stats - Non-Admin */}
        {!isAdmin && (
          <div className="bg-white rounded-2xl shadow-xl p-5 sm:p-6 mb-6 text-center">
            <div className="flex items-center justify-center gap-2">
              <Users className="text-indigo-600" size={32} />
              <div>
                <p className="text-gray-600">Registered Vendors</p>
                <p className="text-3xl font-bold text-indigo-600">{vendors.length}</p>
              </div>
            </div>
          </div>
        )}

        {/* Vendors List - Admin Only */}
        {isAdmin && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
            {filteredVendors.length === 0 ? (
              <div className="md:col-span-2 lg:col-span-3 bg-white rounded-2xl shadow-xl p-10 sm:p-12 text-center">
                <Fuel className="mx-auto text-gray-300 mb-4" size={64} />
                <h3 className="text-xl font-semibold text-gray-600 mb-2">
                  {vendors.length === 0 ? 'No vendors registered yet' : 'No vendors found'}
                </h3>
                <p className="text-gray-500">
                  {vendors.length === 0
                    ? 'Vendors will appear here once registered.'
                    : 'Try adjusting your search criteria.'}
                </p>
              </div>
            ) : (
              filteredVendors.map((vendor) => (
                <div
                  key={vendor.id}
                  className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all p-6 border-2 border-gray-100 hover:border-indigo-200"
                >
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="text-xl font-bold text-gray-800 flex-1">{vendor.business_name}</h3>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEdit(vendor)}
                        className="p-2 text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all"
                        title="Edit"
                      >
                        <Edit2 size={18} />
                      </button>
                      <button
                        onClick={() => handleDelete(vendor.id)}
                        className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-all"
                        title="Delete"
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  </div>

                  <div className="space-y-3">
                    <div className="flex items-start gap-2 text-gray-700">
                      <Users className="text-indigo-500 flex-shrink-0 mt-1" size={16} />
                      <div className="text-sm">
                        <p className="font-semibold">{vendor.contact_person}</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-2 text-gray-700">
                      <Phone className="text-indigo-500 flex-shrink-0 mt-1" size={16} />
                      <div className="text-sm">
                        <p>{vendor.phone}</p>
                      </div>
                    </div>

                    {vendor.email && (
                      <div className="flex items-start gap-2 text-gray-700">
                        <Mail className="text-indigo-500 flex-shrink-0 mt-1" size={16} />
                        <div className="text-sm">
                          <p className="break-all">{vendor.email}</p>
                        </div>
                      </div>
                    )}

                    <div className="flex items-start gap-2 text-gray-700">
                      <MapPin className="text-indigo-500 flex-shrink-0 mt-1" size={16} />
                      <div className="text-sm">
                        <p>{vendor.address}</p>
                        <p className="font-semibold text-indigo-600 mt-1">
                          {vendor.lga}{vendor.lga ? ' LGA' : ''}{vendor.state ? `, ${vendor.state}` : ''}
                        </p>
                      </div>
                    </div>

                    <div className="pt-3 border-t border-gray-200 grid grid-cols-2 gap-2 text-sm">
                      <div>
                        <p className="text-gray-500 text-xs">Gas Type</p>
                        <p className="font-semibold text-gray-800">{vendor.gas_type}</p>
                      </div>
                      <div>
                        <p className="text-gray-500 text-xs">Service</p>
                        <p className="font-semibold text-gray-800">{vendor.service_type}</p>
                      </div>
                    </div>

                    {vendor.price_per_kg && (
                      <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                        <p className="text-xs text-green-700 mb-1">Current Price</p>
                        <p className="text-lg font-bold text-green-800">₦{vendor.price_per_kg}/kg</p>
                      </div>
                    )}

                    {vendor.delivery_available === 'Yes' && (
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 text-center">
                        <p className="text-sm font-semibold text-blue-700">✓ Delivery Available</p>
                      </div>
                    )}

                    {vendor.operating_hours && (
                      <div className="flex items-start gap-2 text-gray-700">
                        <Clock className="text-indigo-500 flex-shrink-0 mt-1" size={16} />
                        <div className="text-sm">
                          <p>{vendor.operating_hours}</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* Footer */}
        <div className="mt-8 text-center text-gray-600 text-sm">
          <p>Nigeria Gas Vendor Registry - Connecting consumers with reliable gas suppliers</p>
          <p className="mt-1">
            Total registered vendors: <span className="font-bold text-indigo-600">{vendors.length}</span>
          </p>
        </div>
      </div>
    </div>
  );
}